var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-button",
        {
          staticClass: "mb10",
          attrs: { type: "primary", name: "" },
          on: { click: _vm.openAddModel },
        },
        [_vm._v("定义 Topic")]
      ),
      _c(
        "div",
        [
          _c(
            "vxe-table",
            { attrs: { "row-id": "topic_id", data: _vm.table, align: "left" } },
            [
              _c("vxe-table-column", {
                attrs: {
                  field: "topic_typeview",
                  "show-overflow": "",
                  "min-width": "50",
                  title: "功能",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "topic",
                  "show-overflow": "",
                  "min-width": "420",
                  title: "Topic",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "topic_powerview",
                  "show-overflow": "",
                  "min-width": "80",
                  title: "操作权限",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "topic_desc",
                  "show-overflow": "",
                  "min-width": "220",
                  title: "描述",
                },
              }),
              _c("vxe-column", {
                attrs: { title: "操作", "min-width": "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (slotProps) {
                      return [
                        _c(
                          "span",
                          { staticClass: "handle-button" },
                          [
                            _c(
                              "v-button",
                              {
                                attrs: {
                                  slot: "reference",
                                  size: "S",
                                  type: "text",
                                  name: "btn-text1",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openViewModel(slotProps.row)
                                  },
                                },
                                slot: "reference",
                              },
                              [_vm._v("查看")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "span",
                          { staticClass: "handle-button" },
                          [
                            _c(
                              "v-button",
                              {
                                attrs: {
                                  slot: "reference",
                                  size: "S",
                                  type: "text",
                                  name: "btn-text1",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openUpdataModel(slotProps.row)
                                  },
                                },
                                slot: "reference",
                              },
                              [_vm._v("编辑")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "span",
                          { staticClass: "handle-button" },
                          [
                            _c(
                              "v-button",
                              {
                                attrs: {
                                  slot: "reference",
                                  size: "S",
                                  type: "text",
                                  name: "btn-text1",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openDelModel(slotProps.row)
                                  },
                                },
                                slot: "reference",
                              },
                              [_vm._v("删除")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("AddTopic", {
        ref: "AddTopic",
        attrs: {
          showInputDialog: _vm.AddTopicloading,
          productKey: _vm.productKey,
        },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.AddTopicloading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.AddTopicloading = $event
          },
          getData: _vm.getData,
        },
      }),
      _c("UpdataTopic", {
        ref: "UpdataTopic",
        attrs: {
          showInputDialog: _vm.UpdataTopicloading,
          updatainfo: _vm.updatainfo,
          productId: _vm.productId,
        },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.UpdataTopicloading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.UpdataTopicloading = $event
          },
          getData: _vm.getData,
        },
      }),
      _c("Del", {
        ref: "Del",
        attrs: { showInputDialog: _vm.Delloading, topicId: _vm.topicId },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.Delloading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.Delloading = $event
          },
          getData: _vm.getData,
        },
      }),
      _c("UpdataAndview", {
        ref: "UpdataAndview",
        attrs: {
          showInputDialog: _vm.UpdataAndviewloading,
          id: _vm.id,
          category: _vm.category,
          topicType: "diy",
        },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.UpdataAndviewloading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.UpdataAndviewloading = $event
          },
          getData: _vm.getData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }